(function () {
  function bindTopLevelSummaries(root) {
    (root || document).querySelectorAll('.site-nav__details > summary').forEach(function (summary) {
      if (summary.hasAttribute('data-starfire-nav')) return;
      summary.setAttribute('data-starfire-nav', '');
      summary.addEventListener(
        'click',
        function (event) {
          event.stopImmediatePropagation();
        },
        true
      );
    });
  }

  function bindHoverGuards(root) {
    (root || document).querySelectorAll('.site-nav__details[data-hover="true"]').forEach(function (detail) {
      if (detail.hasAttribute('data-starfire-hover-guard')) return;
      detail.setAttribute('data-starfire-hover-guard', '');

      var closeTimer = 0;
      var holdOpen = false;

      detail.querySelectorAll('details').forEach(function (nested) {
        if (nested === detail) return;
        nested.addEventListener('toggle', function () {
          holdOpen = true;
          window.clearTimeout(closeTimer);
          if (!detail.hasAttribute('open')) {
            detail.setAttribute('open', '');
            detail.setAttribute('aria-expanded', 'true');
          }
        });
      });

      detail.addEventListener(
        'mouseleave',
        function (event) {
          event.stopImmediatePropagation();
          window.clearTimeout(closeTimer);

          if (holdOpen) {
            holdOpen = false;
            document.addEventListener('mousemove', function onMove(moveEvent) {
              document.removeEventListener('mousemove', onMove);
              var under = document.elementFromPoint(moveEvent.clientX, moveEvent.clientY);
              if (!under || !detail.contains(under)) {
                detail.removeAttribute('open');
                detail.setAttribute('aria-expanded', 'false');
              }
            });
            return;
          }

          closeTimer = window.setTimeout(function () {
            if (detail.matches(':hover')) return;
            detail.removeAttribute('open');
            detail.setAttribute('aria-expanded', 'false');
          }, 80);
        },
        true
      );

      detail.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        holdOpen = false;
      });
    });
  }

  function neutralizeFlyoutMeasure(root) {
    (root || document)
      .querySelectorAll('.site-nav__dropdown:not(.megamenu) .site-nav__deep-dropdown-trigger')
      .forEach(function (trigger) {
        if (trigger.hasAttribute('data-starfire-flyout')) return;
        trigger.setAttribute('data-starfire-flyout', '');
        trigger.addEventListener('mouseenter', function () {
          var dropdown = trigger.querySelector(':scope > details > .site-nav__deep-dropdown');
          if (!dropdown) {
            dropdown = trigger.querySelector('.site-nav__deep-dropdown');
          }
          if (!dropdown) return;
          window.requestAnimationFrame(function () {
            dropdown.style.width = '';
            dropdown.classList.remove('site-nav__deep-dropdown--wrap');
            var menu = trigger.closest('.site-nav__dropdown:not(.megamenu)');
            if (menu) sizeAccordionMenu(menu);
          });
        });
      });
  }

  function isVisibleNestedList(list, menu) {
    var node = list.parentElement;
    while (node && node !== menu) {
      if (node.tagName === 'DETAILS' && !node.open) return false;
      node = node.parentElement;
    }

    var style = window.getComputedStyle(list);
    if (style.position === 'absolute' || style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }

    var rect = list.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function sizeAccordionMenu(menu) {
    if (!menu || menu.classList.contains('megamenu')) return;

    menu.querySelectorAll('.site-nav__deep-dropdown').forEach(function (list) {
      list.style.width = '';
      list.style.maxWidth = '';
    });

    var nested = Array.prototype.filter.call(
      menu.querySelectorAll('details[open] > .site-nav__deep-dropdown'),
      function (list) {
        return isVisibleNestedList(list, menu);
      }
    );

    if (!nested.length) {
      menu.style.width = '';
      return;
    }

    nested.forEach(function (list) {
      list.style.width = 'max-content';
      list.style.maxWidth = 'none';
    });
    menu.style.width = 'max-content';

    var width = menu.scrollWidth;
    nested.forEach(function (list) {
      width = Math.max(width, list.scrollWidth);
    });

    nested.forEach(function (list) {
      list.style.width = '';
      list.style.maxWidth = '';
    });
    menu.style.width = Math.ceil(width) + 'px';
  }

  function bindAccordionWidth(root) {
    (root || document).querySelectorAll('.site-nav__dropdown:not(.megamenu)').forEach(function (menu) {
      if (menu.hasAttribute('data-starfire-width')) return;
      menu.setAttribute('data-starfire-width', '');
      menu.addEventListener(
        'toggle',
        function () {
          window.requestAnimationFrame(function () {
            sizeAccordionMenu(menu);
          });
        },
        true
      );
    });
  }

  function init(root) {
    bindTopLevelSummaries(root);
    bindHoverGuards(root);
    neutralizeFlyoutMeasure(root);
    bindAccordionWidth(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
